Vue.component('category-menu', {
    props: {
        categories: {
            required: true,
        },
        subMenu: {
            default: false,
        },
        active: {
            default: 0,
        },
        offsetRoot: {
            default: true,
        },
    },
    //language=HTML
    template: `
        <ul class="nav flex-column vertical" :class="{'sub-nav': subMenu}">
            <slot name="inUl"></slot>
            <template v-if="offsetRoot">
                <category-menu-item v-for="cat, key in categories" :key="'b'+key" :category="cat" value="all" :active="isActive(cat)" :recursive="false"></category-menu-item>
                <category-menu-item v-for="cat, key in childCategories" :key="'c'+key" :category="cat" :active="isActive(cat)"></category-menu-item>
            </template>
            <template v-else>
                <category-menu-item v-for="cat, key in categories" :key="'a'+key" :category="cat" :active="isActive(cat)"></category-menu-item>
            </template>
            <li>
                <slot name="postMenu"></slot>
            </li>
        </ul>
    `,
    data: () => ({
        cats: null,
    }),
    methods: {
        isActive(cat) {
            return _.toInteger(cat.id) === _.toInteger(this.active);
        },
    },
    computed: {
        childCategories() {
            return _.get(this.categories, '0.children', []);
        },
    },
});
